import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { userContext } from "../context/UserContext";
import CartTableRow from "../component/CartTableRow";
import { api_url } from "../helpers";

const Cart = () => {
  const { cart, user, cartUpdate, setLoad } = useContext(userContext);
  const [cartProducts, setCartProducts] = useState([]);

  async function CartDataFetch() {
    setLoad(true);

    const response = await fetch(
      api_url + `resource/Sales Order/${cart?.sales_order}`,
      {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
        },
      }
    );

    if (response.ok == true) {
      const data = await response.json();
      console.log(data);

      if (data?.data) {
        setCartProducts(data?.data);
      }
    }

    setTimeout(() => {
      setLoad(false);
    }, 300);
  }

  useEffect(() => {
    if (cart?.sales_order){
      CartDataFetch();
    }
  }, [cart]);

  return (
    <section className="cart py-80">
      <div className="container container-lg">
        {cartProducts?.items?.length > 0 ? (
          <div className="row gy-4">
            <div className="col-xl-9 col-lg-8">
              <div className="cart-table border border-gray-100 rounded-8 px-40 py-48">
                <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                  <table className="table style-three">
                    <thead>
                      <tr>
                        <th className="h6 mb-0 text-lg fw-bold">Delete</th>
                        <th className="h6 mb-0 text-lg fw-bold">
                          Product Name
                        </th>
                        <th className="h6 mb-0 text-lg fw-bold">Price</th>
                        <th className="h6 mb-0 text-lg fw-bold">Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartProducts?.items?.length > 0 &&
                        cartProducts?.items?.map((item, index) => (
                          <CartTableRow
                            cartUpdate={cartUpdate}
                            item={item}
                            key={index}
                          />
                        ))}
                    </tbody>
                  </table>
                </div>
                {/* <div className="flex-between flex-wrap gap-16 mt-16">
                  <div className="flex-align gap-16">
                    <input
                      type="text"
                      className="common-input"
                      placeholder="Coupon Code"
                    />
                    <button
                      type="submit"
                      className="btn btn-main py-18 w-100 rounded-8"
                    >
                      Apply Coupon
                    </button>
                  </div>
                  <button
                    type="submit"
                    className="text-lg text-gray-500 hover-text-main-600"
                  >
                    Update Cart
                  </button>
                </div> */}
              </div>
            </div>
            <div className="col-xl-3 col-lg-4">
              <div className="cart-sidebar border border-gray-100 rounded-8 px-24 py-40">
                <h6 className="text-xl mb-32">Cart Totals</h6>
                <div className="bg-color-three rounded-8 p-24">
                  <div className="mb-32 flex-between gap-8">
                    <span className="text-gray-900 font-heading-two">
                      Subtotal
                    </span>
                    <span className="text-gray-900 fw-semibold">
                      {cartProducts?.items.reduce(
                        (sum, item) =>
                          sum + parseFloat(item?.qty) * parseFloat(item?.rate),
                        0
                      )}{" "}
                      KD
                    </span>
                  </div>
                  <div className="mb-32 flex-between gap-8">
                    <span className="text-gray-900 font-heading-two">
                      Extimated Delivery
                    </span>
                    <span className="text-gray-900 fw-semibold">Free</span>
                  </div>
                </div>
                <div className="bg-color-three rounded-8 p-24 mt-24">
                  <div className="flex-between gap-8">
                    <span className="text-gray-900 text-xl fw-semibold">
                      Total
                    </span>
                    <span className="text-gray-900 text-xl fw-semibold">
                      {cartProducts?.items.reduce(
                        (sum, item) =>
                          sum + parseFloat(item?.qty) * parseFloat(item?.rate),
                        0
                      )}{" "}
                      KD
                    </span>
                  </div>
                </div>
                <a
                  href="/checkout"
                  className="btn btn-main mt-40 py-18 w-100 rounded-8"
                >
                  Proceed to checkout
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column align-items-center">
            <div className="w-50">
              <img
                src="assets/images/bg/EmptyCartImage.png"
                alt=""
                className=""
              />
            </div>
            <div className="mt-60">
              <h3 className="d-flex justify-content-center">
                Your Cart is Empty!
              </h3>
              <h6 className="text-secondary mt-24 px-10 text-center">
                Looks like you have no items in your shopping cart.
              </h6>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Cart;
